/* MI CASA — el almacén de paredes guardadas. Cuadros Splash (24 sep 2026).

   Cada "pared" es una escena del probador (Cuélgalo en tu casa): la foto del
   cliente, la obra, la talla y todo lo necesario para reabrirla tal cual la
   dejó (medida, perspectiva, posición, luz), más una imagen ya montada para
   enseñarla en la página Mi casa.

   Dónde vive: en IndexedDB, en ESTE navegador. Igual que los favoritos: sin
   cuenta y sin servidor. Es lo que promete la política de privacidad
   (apartado 5): las fotos de las casas no se guardan en ningún sitio nuestro.
   Si el cliente cambia de móvil, no las ve; es el precio de esa promesa.

   API (window.csMiCasa), todo con promesas:
     disponible          → true si el navegador deja guardar
     ESTANCIAS           → [[clave, nombre], ...] en el orden de la página
     nombre(clave)       → "Salón"
     guardar(escena)     → id   (nueva, o la sustituye si trae id)
     leer(id)            → escena
     todas()             → [escena, ...] de la más nueva a la más vieja
     borrar(id)
     mover(id, estancia)
     contar()            → número
   Tras cada cambio se lanza `cs:mi-casa-cambio` en document.
*/
(function () {
  'use strict';

  var ESTANCIAS = [
    ['salon', 'Salón'],
    ['dormitorio', 'Dormitorio'],
    ['comedor', 'Comedor'],
    ['cocina', 'Cocina'],
    ['bano', 'Baño'],
    ['entrada', 'Entrada'],
    ['despacho', 'Despacho'],
    ['infantil', 'Infantil'],
    ['otros', 'Otros espacios'],
  ];

  function nombre(clave) {
    for (var i = 0; i < ESTANCIAS.length; i++) if (ESTANCIAS[i][0] === clave) return ESTANCIAS[i][1];
    return 'Otros espacios';
  }

  var BASE = 'cs-mi-casa', ALMACEN = 'paredes';
  var abierta = null;

  function abrir() {
    if (abierta) return abierta;
    abierta = new Promise(function (ok, mal) {
      if (!window.indexedDB) { mal(new Error('sin indexeddb')); return; }
      var pet;
      try { pet = window.indexedDB.open(BASE, 1); } catch (e) { mal(e); return; }
      pet.onupgradeneeded = function () {
        var db = pet.result;
        if (!db.objectStoreNames.contains(ALMACEN)) db.createObjectStore(ALMACEN, { keyPath: 'id' });
      };
      pet.onsuccess = function () { ok(pet.result); };
      pet.onerror = function () { mal(pet.error); };
      pet.onblocked = function () { mal(new Error('bloqueada')); };
    });
    abierta.catch(function () { abierta = null; });
    return abierta;
  }

  function tx(modo, fn) {
    return abrir().then(function (db) {
      return new Promise(function (ok, mal) {
        var t = db.transaction(ALMACEN, modo);
        var alm = t.objectStore(ALMACEN);
        var res;
        var r = fn(alm);
        if (r) r.onsuccess = function () { res = r.result; };
        t.oncomplete = function () { ok(res); };
        t.onerror = function () { mal(t.error); };
        t.onabort = function () { mal(t.error || new Error('abortada')); };
      });
    });
  }

  /* La casita de la cabecera (sections/header.liquid) no carga este
     archivo: lee el número de paredes de localStorage ('cs-mi-casa-n'),
     que se apunta aquí cada vez que cambia algo. */
  function apuntarCuenta() {
    return api.contar().then(function (n) {
      try { localStorage.setItem('cs-mi-casa-n', String(n)); } catch (e) { /* sin almacén */ }
      var b = document.getElementById('micasa-count-bubble');
      if (b) {
        var s = b.querySelector('[data-count]');
        if (s) s.textContent = n;
        b.hidden = !n;
      }
      document.querySelectorAll('[data-micasa-n]').forEach(function (e) { e.textContent = n ? '(' + n + ')' : ''; });
      var i = document.getElementById('micasa-icon-bubble');
      if (i) i.classList.toggle('tiene-paredes', n > 0);
      return n;
    });
  }

  function avisar() {
    apuntarCuenta();
    try { document.dispatchEvent(new CustomEvent('cs:mi-casa-cambio')); } catch (e) { /* nada */ }
  }

  function nuevoId() {
    return 'p' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  }

  var api = {
    ESTANCIAS: ESTANCIAS,
    nombre: nombre,
    disponible: !!window.indexedDB,

    guardar: function (escena) {
      var ahora = Date.now();
      escena.id = escena.id || nuevoId();
      escena.creada = escena.creada || ahora;
      escena.actualizada = ahora;
      if (!escena.estancia || !ESTANCIAS.some(function (e) { return e[0] === escena.estancia; })) escena.estancia = 'otros';
      return tx('readwrite', function (a) { return a.put(escena); }).then(function () {
        avisar();
        return escena.id;
      });
    },

    leer: function (id) {
      return tx('readonly', function (a) { return a.get(id); });
    },

    todas: function () {
      return tx('readonly', function (a) { return a.getAll(); }).then(function (l) {
        return (l || []).sort(function (x, y) { return (y.actualizada || 0) - (x.actualizada || 0); });
      });
    },

    borrar: function (id) {
      return tx('readwrite', function (a) { return a.delete(id); }).then(avisar);
    },

    mover: function (id, estancia) {
      return api.leer(id).then(function (e) {
        if (!e) return;
        e.estancia = estancia;
        return tx('readwrite', function (a) { return a.put(e); }).then(avisar);
      });
    },

    contar: function () {
      return tx('readonly', function (a) { return a.count(); }).catch(function () { return 0; });
    },
  };

  window.csMiCasa = api;
  /* Donde se carga (probador y Mi casa), se corrige el número guardado por
     si se borraron los datos del navegador. */
  if (api.disponible) apuntarCuenta();
})();
